function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _require = require('./normalization'),
  deepNormalizeAttributes = _require.deepNormalizeAttributes;
var _require2 = require('./util'),
  isNonEmptyObject = _require2.isNonEmptyObject;
var buildCallback = require('./buildCallback');

/**
 * Pushes the provided `eventData` object to the `window.dataLayer` array.
 * `window.dataLayer` will be created as an empty array if it does not yet exist.
 * @param {Object} [eventData]
 */
var pushToDataLayer = function pushToDataLayer(eventData) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(eventData);
};

/**
 * @typedef sendPageViewEventOptions
 * @property {Object} pageAttributes
 * @property {?Object} [userAttributes]
 * @property {?Function} [callback]
 * @property {?(import('./defaultConfig').Config)} [customConfig]
 */

/**
 * Sets new page attributes by pushing them to the dataLayer, and then triggers a page view
 * event by pushing an 'analytics_ready' message to the dataLayer afterwards.
 * @param {sendPageViewEventOptions} options
 * @returns {void}
 */
var sendPageViewEvent = function sendPageViewEvent(_ref) {
  var pageAttributes = _ref.pageAttributes,
    _ref$userAttributes = _ref.userAttributes,
    userAttributes = _ref$userAttributes === void 0 ? null : _ref$userAttributes,
    _ref$callback = _ref.callback,
    callback = _ref$callback === void 0 ? null : _ref$callback,
    _ref$customConfig = _ref.customConfig,
    customConfig = _ref$customConfig === void 0 ? {} : _ref$customConfig;
  var pageAttributesPayload = _objectSpread(_objectSpread({}, deepNormalizeAttributes(pageAttributes, {
    stringifyArrays: true,
    customConfig: customConfig
  })), {}, {
    event_attributes: null // Clear any previous event attributes data from the dataLayer
  });

  // We only want to include `user_attributes` in the payload if we have new user attributes to set.
  if (isNonEmptyObject(userAttributes)) {
    pageAttributesPayload.user_attributes = deepNormalizeAttributes(userAttributes, {
      stringifyArrays: true,
      customConfig: customConfig
    });
  }
  pushToDataLayer(pageAttributesPayload);
  pushToDataLayer({
    event: 'analytics_ready',
    eventCallback: buildCallback(callback),
    event_attributes: {
      event_type: 'user',
      custom_timestamp: Date.now()
    }
  });
};
module.exports = sendPageViewEvent;